var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "color-size-error-wrapper" }, [
    _c(
      "div",
      {
        staticClass: "color-size-wrapper",
        class: {
          "color-size-wrapper--invalid":
            !(_vm.isValidColor && _vm.isValidSize) && !_vm.showValidation
        }
      },
      [
        _vm.hasColors
          ? _c("select-option", {
              attrs: {
                name: "product_color",
                id: "product_color",
                options: _vm.colors,
                selectedValue: _vm.selectedColorId,
                defaultValue: "Select Color",
                isPristine: _vm.pristineStatus["color"]
              },
              on: {
                change: function(event) {
                  return _vm.$emit("color-changed", event)
                }
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("select-option", {
          attrs: {
            name: "product_size",
            id: "product_size",
            options: _vm.sizes,
            selectedValue: _vm.selectedSizeId,
            disabled: !_vm.hasColorSelected,
            defaultValue: "Select Size",
            isPristine: _vm.pristineStatus["size"]
          },
          on: { change: _vm.sizeChanged, click: _vm.sizeClicked },
          scopedSlots: _vm._u([
            {
              key: "option-sidetitle",
              fn: function(slotProps) {
                return [
                  _vm.showOOSMessage(slotProps.option)
                    ? _c("span", { staticClass: "oos-size-message" }, [
                        _vm._v(
                          "\n                    - Please choose another size\n                "
                        )
                      ])
                    : _vm._e()
                ]
              }
            }
          ])
        })
      ],
      1
    ),
    _vm._v(" "),
    _vm.showValidation
      ? _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.validationMessage,
                expression: "validationMessage"
              }
            ],
            staticClass: "color-size-error"
          },
          [_vm._v("\n        " + _vm._s(_vm.validationMessage) + "\n    ")]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46c27726", { render: render, staticRenderFns: staticRenderFns })
  }
}